export default "__VITE_ASSET__CMnsZ4Yu__"